import {
  BASE_OTT_DIMENSIONS,
  INSTALL_COHORT_OTT_DIMENSIONS,
  REENGAGEMENT_OTT_DIMENSIONS,
} from '../../../../shared/constants/ottDimensions';
import type { CohortType } from '../types/cohortTypes';

export const conditionallyExtendWithOttDimensions = (baseDimensions: string[], isOttEnabled: boolean): string[] => {
  if (isOttEnabled) {
    return [...baseDimensions, ...BASE_OTT_DIMENSIONS];
  }

  return baseDimensions;
};

export const conditionallyExtendWithCohortsOttDimensions = (
  baseDimensions: string[],
  cohortType: CohortType | string,
  isOttEnabled: boolean
): string[] => {
  if (isOttEnabled) {
    if (cohortType === 'install_cohort') {
      return [...baseDimensions, ...INSTALL_COHORT_OTT_DIMENSIONS];
    }

    if (cohortType === 'reengagement_cohort') {
      return [...baseDimensions, ...REENGAGEMENT_OTT_DIMENSIONS];
    }
  }

  return baseDimensions;
};
